<template>
  <div v-if="visible"
       class="delete-confirm-backdrop"
       @click.self="$emit('close')">
    <div class="delete-confirm-card"
         role="dialog"
         aria-modal="true">
      <div class="delete-confirm-header">
        <h4>{{ type === 'group' ? 'Excluir grupo' : 'Excluir subgrupo' }}</h4>
        <button class="delete-confirm-close-btn"
                @click="$emit('close')"
                aria-label="Fechar"><i class="fa-regular fa-x"></i></button>
      </div>

      <div class="delete-confirm-body">
        <CheckboxSimple title="Remover registros vinculados"
                        :markFormDirty="false"
                        v-model="deleteProductsLocal"/>
      </div>

      <div class="delete-confirm-actions">
        <div class="delete-confirm-action-item">
          <Button _key="cancelDeleteConfirm"
                  type="edit"
                  title="Cancelar"
                  size="small"
                  :clicked="close"/>
        </div>
        <div class="delete-confirm-action-item">
          <Button _key="confirmDeleteConfirm"
                  type="danger"
                  title="Confirmar"
                  size="medium"
                  :clicked="confirm"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple.vue";

import {mapMutations} from "vuex";

export default {
  name: "ConfirmDelete",
  components: {
    Button,
    CheckboxSimple,
  },
  props: {
    visible: {type: Boolean, default: false},
    type: {type: String, default: "group"},
    deleteProducts: {type: Boolean, default: false},
  },
  computed: {
    deleteProductsLocal: {
      get() {
        return this.deleteProducts;
      },
      set(value) {
        this.$emit("update:deleteProducts", value);
      },
    },
  },
  methods: {
    ...mapMutations("generic", ["removeLoading"]),
    close() {
      this.$emit("close");
      this.removeLoading(["cancelDeleteConfirm"]);
    },
    confirm() {
      this.$emit("confirm");
      this.removeLoading(["confirmDeleteConfirm"]);
    },
  },
};
</script>

<style scoped>
.delete-confirm-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.36);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.delete-confirm-card {
  width: 100%;
  max-width: 460px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.2);
}

.delete-confirm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
}

.delete-confirm-header h4 {
  margin: 0;
  font-size: 17px;
  color: #111827;
}

.delete-confirm-close-btn {
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
}

.delete-confirm-close-btn:hover {
  color: #111827;
}

.delete-confirm-body {
  padding: 16px;
}

.delete-confirm-body p {
  margin: 0 0 14px 0;
  color: #4b5563;
}

.delete-confirm-actions {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px 16px 16px;
}

.delete-confirm-action-item {
  display: inline-flex;
}
</style>
